module.exports = __webpack_public_path__ + "static/media/bottom (2).6511c728.png";